import axios from 'axios'
import { isTraceabilityEnabled } from '@/utils/feature-toggle'

const getAxiosInstance = () => {
  axios.defaults.baseURL = process.env.TRACEABILITY_BASE_URL

  return axios
}

export const getNtoList = async () =>
  isTraceabilityEnabled()
    ? await getAxiosInstance().get('/ntosNames')
    : { data: [] }

export const getProductionNTOs = async filter =>
  isTraceabilityEnabled()
    ? await getAxiosInstance().get('/ntos', { params: filter })
    : { data: [] }

export const getLogisticNTOsByBatches = async filter =>
  isTraceabilityEnabled()
    ? await getAxiosInstance().get('/lot/ntos', { params: filter })
    : { data: [] }

export const getLogisticNTOsBySamples = async filter =>
  isTraceabilityEnabled()
    ? await getAxiosInstance().get('/samples/ntos', { params: filter })
    : { data: [] }

export const getProductionIndicators = async filter =>
  isTraceabilityEnabled()
    ? await getAxiosInstance().get('/exams/indicators', { params: filter })
    : { data: {} }

export const getLogisticBatchIndicators = async filter =>
  isTraceabilityEnabled()
    ? await getAxiosInstance().get('/lot/indicators', { params: filter })
    : { data: {} }

export const getLogisticSampleIndicators = async filter =>
  isTraceabilityEnabled()
    ? await getAxiosInstance().get('/samples/indicators', { params: filter })
    : { data: {} }

export const getGroupedExamsCount = async filter =>
  isTraceabilityEnabled()
    ? await getAxiosInstance().get('/exams/grouped/count', { params: filter })
    : { data: {} }

export const getBatchSearchDetailsByBarcode = async barcode =>
  isTraceabilityEnabled()
    ? await getAxiosInstance().get(`/lotDetails/${barcode}`)
    : { data: {} }
